import { render } from "./AuthInfo.vue?vue&type=template&id=45c9b86e&ts=true"
import script from "./AuthInfo.vue?vue&type=script&lang=ts"
export * from "./AuthInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/runner/_work/OrderpadConfigurationWeb/OrderpadConfigurationWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__